import { useAppSelector } from '@/store/hook'
import { isValidArray } from '@/libs/utils/array'

import { selectUserRightList } from '../store/selectors/roleSelector'

export default function usePermission(requiredPermission) {
  const userRights = useAppSelector(selectUserRightList)
  const mappedRights = new Set(userRights)

  const checkPermission = (right) => mappedRights.has(right)

  const checkMultiplePermissions = (rights) => {
    if (isValidArray(rights)) {
      return rights.map(checkPermission)
    }

    return []
  }

  if (isValidArray(requiredPermission)) {
    const verifiedPermissions = checkMultiplePermissions(requiredPermission)

    const hasPermission = verifiedPermissions.every(
      (verifiedPermission) => verifiedPermission,
    )

    return {
      hasPermission,
      verifiedPermissions,
      checkPermission,
      checkMultiplePermissions,
    }
  }

  return {
    hasPermission: checkPermission(requiredPermission),
    checkPermission,
    checkMultiplePermissions,
  }
}
